import { render, staticRenderFns } from "./RoutinesTable.vue?vue&type=template&id=62470f12&"
import script from "./RoutinesTable.vue?vue&type=script&lang=js&"
export * from "./RoutinesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports